/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from './UIAssetKeys';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, MM_ANIMATIONS.key, MM_ANIMATIONS.frames);
  fixPivot(mainTex, MARBLE_DROP_ANIMATION.key, MARBLE_DROP_ANIMATION.frames);
  fixPivot(mainTex, PENGUIN_TALKING_ANIMATIONS.key, PENGUIN_TALKING_ANIMATIONS.frames);
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 * @param {{animations:any}} animationData
 * @param {string} animationKey 
 */
export function addAnimationToSprite(sprite, animationData, animationKey, play = true, loop = false) {
  const animationFramesData = animationData.animations[animationKey];
  if (animationFramesData.frames.length === 1) {
    sprite.stop();

    // this animation only has 1 frame, just set it
    sprite.setFrame(animationData.key + animationFramesData.frames[0]);
    return;
  }
  if (sprite.anims.exists(animationKey)) {
    if (play) sprite.play(animationKey);
    return;
  }

  const frames = [];
  animationFramesData.frames.forEach(frameNum => frames.push({ frame: animationData.key + frameNum.toString() }));
  sprite.anims.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: animationFramesData.framerate ?? 24,
      key: animationKey,
      frames,
      repeat: loop ? -1 : 0
    }
  );
  if (animationFramesData.next !== null && animationFramesData.next !== undefined) {
    if (animationData.animations[animationFramesData.next].frames.length > 1) {
      if (!sprite.anims.exists(animationFramesData.next)) {
        addAnimationToSprite(sprite,animationData, animationFramesData.next, false);
      }
    }
    sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + animationKey, () => {
      if (animationData.animations[animationFramesData.next].frames.length === 1) {
        // the next "animation" is just a frame, set it
        sprite.setFrame(animationData.key + animationData.animations[animationFramesData.next].frames[0]);
      }
      else {
        sprite.play(animationFramesData.next);
      }
    });
  }
  if (play) sprite.play(animationKey);
}


// this data comes from the original game; this is the CreateJs sprite sheet animation export
export const MM_ANIMATIONS = {
  key: 'mmAnimations/',
  frames: [
    [2009, 691, 39, 48, 0, -8, -36],
    [2006, 463, 42, 52, 0, -7, -33],
    [1908, 2, 45, 55, 1, -5, -30],
    [1860, 2, 48, 60, 1, -4, -26],
    [1810, 2, 50, 64, 1, -3, -23],
    [1757, 2, 53, 68, 1, -1, -20],
    [1645, 2, 56, 72, 1, 0, -17],
    [1589, 2, 56, 72, 1, 0, -17],
    [1477, 2, 56, 72, 1, 0, -17],
    [1701, 2, 56, 72, 1, 0, -17],
    [1533, 2, 56, 72, 1, 0, -17],
    [1422, 2, 55, 76, 1, -3, -17],
    [1367, 2, 55, 80, 1, -6, -17],
    [1313, 2, 54, 84, 1, -9, -17],
    [1261, 2, 52, 91, 1, -13, -14],
    [1961, 1602, 51, 100, 0, -16, -9],
    [1963, 1147, 49, 108, 0, -20, -5],
    [1915, 1602, 46, 106, 0, -24, -10],
    [2005, 234, 45, 105, 0, -27, -14],
    [2027, 2, 4, 4, 0, 0, 0],
    [1519, 919, 103, 228, 0, -26, -13],
    [485, 1147, 138, 228, 0, -10, -13],
    [140, 2, 138, 227, 1, -10, -13],
    [2, 2, 138, 227, 1, -10, -13],
    [1776, 1602, 139, 227, 0, -9, -13],
    [979, 2, 139, 224, 1, -9, -13],
    [278, 2, 139, 226, 1, -9, -13],
    [1455, 691, 139, 228, 0, -10, -13],
    [417, 2, 140, 226, 1, -10, -13],
    [838, 2, 141, 224, 1, -10, -13],
    [1634, 1602, 142, 227, 0, -10, -13],
    [1118, 2, 143, 224, 1, -10, -13],
    [696, 2, 142, 226, 1, -10, -13],
    [105, 691, 141, 228, 0, -10, -13],
    [246, 691, 140, 228, 0, -10, -13],
    [386, 691, 139, 228, 0, -10, -13],
    [2, 919, 139, 228, 0, -10, -13],
    [382, 919, 139, 228, 0, -10, -13],
    [521, 919, 140, 228, 0, -10, -13],
    [661, 919, 142, 228, 0, -9, -13],
    [803, 919, 142, 228, 0, -9, -13],
    [945, 919, 143, 228, 0, -9, -13],
    [1088, 919, 143, 228, 0, -9, -13],
    [1231, 919, 145, 228, 0, -8, -13],
    [1376, 919, 143, 228, 0, -9, -13],
    [1622, 919, 143, 228, 0, -9, -13],
    [726, 1147, 142, 228, 0, -9, -13],
    [1765, 919, 142, 228, 0, -9, -13],
    [1907, 919, 140, 228, 0, -10, -13],
    [2, 1147, 139, 228, 0, -10, -13],
    [141, 1147, 138, 228, 0, -10, -13],
    [1350, 1375, 139, 227, 0, -10, -14],
    [1212, 1375, 138, 227, 0, -11, -14],
    [1074, 1375, 138, 227, 0, -11, -14],
    [935, 1375, 139, 227, 0, -10, -14],
    [797, 1375, 138, 227, 0, -11, -14],
    [659, 1375, 138, 227, 0, -11, -14],
    [557, 2, 139, 226, 1, -11, -15],
    [417, 1375, 138, 227, 0, -11, -14],
    [279, 1375, 138, 227, 0, -11, -14],
    [140, 1375, 139, 227, 0, -10, -14],
    [2, 1375, 138, 227, 0, -11, -14],
    [1824, 1147, 139, 227, 0, -10, -14],
    [1905, 1375, 139, 227, 0, -10, -14],
    [141, 919, 138, 228, 0, -10, -13],
    [279, 919, 103, 228, 0, -26, -13],
    [382, 1147, 103, 228, 0, -26, -13],
    [279, 1147, 103, 228, 0, -26, -13],
    [623, 1147, 103, 228, 0, -26, -13],
    [868, 1147, 103, 228, 0, -26, -13],
    [1514, 1147, 103, 227, 0, -26, -14],
    [1427, 1602, 103, 227, 0, -26, -14],
    [1323, 1602, 104, 227, 0, -26, -14],
    [1179, 1147, 103, 227, 0, -26, -14],
    [971, 1147, 103, 227, 0, -26, -14],
    [1410, 1147, 104, 227, 0, -26, -14],
    [555, 1375, 104, 227, 0, -26, -14],
    [1721, 1147, 103, 227, 0, -26, -14],
    [1617, 1147, 104, 227, 0, -26, -14],
    [1489, 1375, 104, 227, 0, -26, -14],
    [1593, 1375, 104, 227, 0, -26, -14],
    [1697, 1375, 104, 227, 0, -26, -14],
    [1530, 1602, 104, 227, 0, -26, -14],
    [1801, 1375, 104, 227, 0, -26, -14],
    [2, 1602, 104, 227, 0, -26, -14],
    [106, 1602, 104, 227, 0, -26, -14],
    [210, 1602, 104, 227, 0, -26, -14],
    [314, 1602, 104, 227, 0, -26, -14],
    [418, 1602, 104, 227, 0, -26, -14],
    [522, 1602, 104, 227, 0, -26, -14],
    [626, 1602, 103, 227, 0, -26, -14],
    [729, 1602, 103, 227, 0, -26, -14],
    [832, 1602, 103, 227, 0, -26, -14],
    [935, 1602, 103, 227, 0, -26, -14],
    [1906, 691, 103, 228, 0, -26, -13],
    [1802, 691, 104, 228, 0, -25, -13],
    [1698, 691, 104, 228, 0, -25, -13],
    [1594, 691, 104, 228, 0, -25, -13],
    [2, 691, 103, 228, 0, -25, -13],
    [1351, 691, 104, 228, 0, -25, -13],
    [1248, 691, 103, 228, 0, -25, -13],
    [1145, 691, 103, 228, 0, -25, -13],
    [1042, 691, 103, 228, 0, -25, -13],
    [939, 691, 103, 228, 0, -25, -13],
    [836, 691, 103, 228, 0, -25, -13],
    [732, 691, 104, 228, 0, -24, -13],
    [629, 691, 103, 228, 0, -25, -13],
    [525, 691, 104, 228, 0, -24, -13],
    [1361, 2, 104, 229, 0, -24, -12],
    [1465, 2, 104, 229, 0, -24, -12],
    [1717, 2, 104, 229, 0, -24, -12],
    [1821, 2, 103, 229, 0, -25, -12],
    [148, 234, 104, 229, 0, -24, -12],
    [1798, 463, 104, 228, 0, -24, -13],
    [1695, 463, 103, 228, 0, -25, -13],
    [1592, 463, 103, 228, 0, -25, -13],
    [1489, 463, 103, 228, 0, -25, -13],
    [1386, 463, 103, 228, 0, -25, -13],
    [1283, 463, 103, 228, 0, -25, -13],
    [1180, 463, 103, 228, 0, -25, -13],
    [1076, 463, 104, 228, 0, -25, -13],
    [972, 463, 104, 228, 0, -25, -13],
    [869, 463, 103, 228, 0, -25, -13],
    [765, 463, 104, 228, 0, -25, -13],
    [661, 463, 104, 228, 0, -25, -13],
    [557, 463, 104, 228, 0, -25, -13],
    [453, 463, 104, 228, 0, -25, -13],
    [349, 463, 104, 228, 0, -25, -13],
    [246, 463, 103, 228, 0, -26, -13],
    [143, 463, 103, 228, 0, -26, -13],
    [1924, 2, 103, 229, 0, -26, -12],
    [394, 234, 103, 229, 0, -26, -12],
    [212, 2, 103, 230, 0, -26, -11],
    [315, 2, 138, 230, 0, -10, -11],
    [497, 234, 103, 229, 0, -26, -12],
    [1409, 234, 103, 228, 0, -26, -13],
    [1271, 234, 138, 228, 0, -10, -13],
    [1132, 234, 139, 228, 0, -9, -11],
    [1073, 2, 142, 229, 0, -7, -8],
    [884, 234, 144, 228, 0, -5, -6],
    [2, 234, 146, 229, 0, -3, -3],
    [1569, 2, 148, 229, 0, -2, -1],
    [1215, 2, 146, 229, 0, -3, -3],
    [740, 234, 144, 228, 0, -5, -6],
    [252, 234, 142, 229, 0, -7, -8],
    [600, 234, 140, 228, 0, -9, -11],
    [1865, 234, 140, 228, 0, -10, -11],
    [2, 463, 141, 228, 0, -10, -9],
    [1181, 1602, 142, 227, 0, -11, -7],
    [1038, 1602, 143, 227, 0, -11, -5],
    [1512, 234, 145, 228, 0, -11, -2],
    [1282, 1147, 128, 227, 0, -18, -5],
    [1074, 1147, 105, 227, 0, -25, -7],
    [1028, 234, 104, 228, 0, -26, -9],
    [1657, 234, 104, 228, 0, -26, -11],
    [1902, 463, 104, 228, 0, -26, -13],
    [867, 2, 103, 229, 0, -27, -12],
    [763, 2, 104, 229, 0, -27, -12],
    [970, 2, 103, 229, 0, -28, -12],
    [107, 2, 105, 230, 0, -27, -11],
    [2, 2, 105, 232, 0, -27, -9],
    [453, 2, 103, 229, 0, -28, -12],
    [659, 2, 104, 229, 0, -27, -12],
    [556, 2, 103, 229, 0, -27, -12],
    [1761, 234, 104, 228, 0, -26, -13]
  ],
  animations: {
    'game stop': { speed: 0.5, frames: [65] },
    locked: { speed: 0.5, frames: [0], next: 'locked' },
    'intro idle': {
      speed: 0.5,
      frames: [
        21,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        36,
        21,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        21
      ]
    },
    'game idle': {
      speed: 0.5,
      frames: [
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        65
      ]
    },
    flap: {
      speed: 0.5,
      frames: [
        65,
        129,
        130,
        131,
        132,
        133,
        133,
        133,
        133,
        132,
        134,
        135,
        65
      ]
    },
    'intro run': {
      speed: 0.5,
      frames: [
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        21
      ]
    },
    opening: {
      speed: 0.5,
      frames: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18
      ],
      next: 'open'
    },
    open: { speed: 0.5, frames: [19] },
    locked2: { speed: 0.5, frames: [0, 0] },
    incorrect: {
      speed: 0.5,
      frames: [
        65,
        155,
        156,
        157,
        158,
        159,
        159,
        159,
        159,
        159,
        160,
        160,
        160,
        160,
        160,
        159,
        159,
        159,
        159,
        160,
        160,
        160,
        160,
        160,
        159,
        161,
        162,
        163,
        164,
        65
      ],
      next: 'game idle'
    },
    correct: {
      speed: 0.5,
      frames: [
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        136,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        65
      ],
      next: 'game idle'
    },
    'intro stop': { speed: 0.5, frames: [20], next: 'intro stop' }
  }
};

export const MARBLE_DROP_ANIMATION = {
  key: 'MarbleDropAnimationSmall/',
  frames: [
    [2, 2, 256, 128, 0, -5, -7],
    [262, 2, 256, 128, 0, -5, -7],
    [522, 2, 256, 128, 0, -5, -7],
    [782, 2, 256, 128, 0, -5, -7],
    [1042, 2, 256, 128, 0, -5, -7],
    [1302, 2, 256, 128, 0, -5, -7],
    [1562, 2, 256, 128, 0, -5, -7],
    [2, 134, 256, 128, 0, -5, -7],
    [262, 134, 256, 128, 0, -5, -7],
    [522, 134, 256, 128, 0, -5, -7],
    [782, 134, 256, 128, 0, -5, -7],
    [1042, 134, 256, 128, 0, -5, -7],
    [1302, 134, 256, 128, 0, -5, -7],
    [1562, 134, 256, 128, 0, -5, -7],
    [2, 266, 256, 128, 0, -5, -7],
    [262, 266, 256, 128, 0, -5, -7],
    [522, 266, 256, 128, 0, -5, -7]
  ],
  animations: {
    run: {
      speed: 0.5,
      frames: [0, 1, 2, 3, 4, 5, 6, 7, 0],
      next: 'run'
    },
    idle: { speed: 0.5, frames: [0], next: 'idle' },
    dump: {
      speed: 0.5,
      frames: [0, 8, 9, 10, 11, 12, 13, 14, 14, 14, 14, 14, 15, 16, 0],
      next: 'idle'
    }
  }
};

export const PENGUIN_TALKING_ANIMATIONS = {
  key: 'PenguinTalking/',
  frames: [
    [1867, 1137, 169, 377, 0, -19, -10],
    [2, 379, 170, 377, 1, -19, -10],
    [509, 2, 169, 377, 1, -20, -10],
    [342, 379, 170, 377, 1, -19, -10],
    [848, 2, 169, 377, 1, -20, -10],
    [1017, 2, 169, 377, 1, -20, -10],
    [1186, 2, 169, 377, 1, -20, -10],
    [512, 379, 169, 377, 1, -20, -10],
    [509, 756, 169, 376, 1, -20, -11],
    [340, 756, 169, 376, 1, -20, -11],
    [171, 756, 169, 376, 1, -20, -11],
    [2, 756, 169, 376, 1, -20, -11],
    [1869, 379, 169, 376, 1, -20, -11],
    [1699, 379, 170, 376, 1, -20, -11],
    [1529, 379, 170, 376, 1, -20, -11],
    [1359, 379, 170, 376, 1, -20, -11],
    [1190, 379, 169, 376, 1, -20, -11],
    [1355, 756, 169, 376, 1, -20, -11],
    [678, 2, 170, 377, 1, -19, -10],
    [172, 379, 170, 377, 1, -19, -10],
    [1186, 1515, 169, 377, 0, -19, -10],
    [1017, 1515, 169, 377, 0, -19, -10],
    [1525, 2, 170, 377, 1, -18, -10],
    [1355, 2, 170, 377, 1, -18, -10],
    [1865, 2, 170, 377, 1, -18, -10],
    [1695, 2, 170, 377, 1, -18, -10],
    [340, 759, 169, 378, 0, -18, -9],
    [509, 759, 169, 378, 0, -18, -9],
    [678, 759, 169, 378, 0, -18, -9],
    [847, 759, 169, 378, 0, -18, -9],
    [1016, 759, 169, 378, 0, -18, -9],
    [1185, 759, 170, 378, 0, -17, -9],
    [1355, 759, 170, 378, 0, -17, -9],
    [2, 2, 169, 379, 0, -17, -8],
    [171, 2, 169, 379, 0, -17, -8],
    [1523, 2, 169, 379, 0, -17, -8],
    [1185, 2, 169, 379, 0, -17, -8],
    [1016, 2, 169, 379, 0, -17, -8],
    [847, 2, 169, 379, 0, -17, -8],
    [1692, 2, 169, 379, 0, -18, -8],
    [1525, 759, 170, 378, 0, -17, -9],
    [1695, 759, 169, 378, 0, -18, -9],
    [1864, 759, 169, 378, 0, -18, -9],
    [171, 759, 169, 378, 0, -18, -9],
    [2, 1137, 169, 378, 0, -18, -9],
    [680, 1137, 169, 378, 0, -18, -9],
    [341, 1137, 169, 378, 0, -18, -9],
    [510, 1137, 170, 378, 0, -18, -9],
    [2, 759, 169, 378, 0, -18, -9],
    [849, 1137, 170, 378, 0, -18, -9],
    [1019, 1137, 170, 378, 0, -18, -9],
    [171, 1137, 170, 378, 0, -18, -9],
    [171, 1515, 169, 377, 0, -19, -10],
    [1528, 1137, 169, 377, 0, -19, -10],
    [1189, 1137, 169, 377, 0, -19, -10],
    [1358, 1137, 170, 377, 0, -19, -10],
    [2, 1515, 169, 377, 0, -20, -10],
    [678, 1515, 169, 377, 0, -20, -10],
    [340, 1515, 169, 377, 0, -20, -10],
    [509, 1515, 169, 377, 0, -20, -10],
    [1524, 756, 169, 376, 1, -20, -11],
    [1862, 756, 169, 376, 1, -20, -11],
    [1693, 756, 169, 376, 1, -20, -11],
    [1186, 756, 169, 376, 1, -20, -11],
    [1017, 756, 169, 376, 1, -20, -11],
    [848, 756, 169, 376, 1, -20, -11],
    [678, 756, 170, 376, 1, -20, -11],
    [1020, 379, 170, 376, 1, -20, -11],
    [850, 379, 170, 376, 1, -20, -11],
    [681, 379, 169, 376, 1, -20, -11],
    [1697, 1137, 170, 377, 0, -19, -10],
    [2, 2, 169, 377, 1, -19, -10],
    [1355, 1515, 169, 377, 0, -19, -10],
    [1524, 1515, 170, 377, 0, -18, -10],
    [1694, 1515, 170, 377, 0, -18, -10],
    [1864, 1515, 170, 377, 0, -18, -10],
    [847, 1515, 170, 377, 0, -18, -10],
    [1019, 381, 169, 378, 0, -18, -9],
    [850, 381, 169, 378, 0, -18, -9],
    [681, 381, 169, 378, 0, -18, -9],
    [511, 381, 170, 378, 0, -17, -9],
    [341, 381, 170, 378, 0, -17, -9],
    [509, 2, 169, 379, 0, -17, -8],
    [678, 2, 169, 379, 0, -17, -8],
    [340, 2, 169, 379, 0, -17, -8],
    [1354, 2, 169, 379, 0, -18, -8],
    [2, 381, 170, 378, 0, -17, -9],
    [1861, 2, 169, 378, 0, -18, -9],
    [172, 381, 169, 378, 0, -18, -9],
    [1188, 381, 169, 378, 0, -18, -9],
    [1357, 381, 170, 378, 0, -18, -9],
    [1527, 381, 169, 378, 0, -18, -9],
    [1696, 381, 170, 378, 0, -18, -9],
    [1866, 381, 170, 378, 0, -18, -9],
    [171, 2, 169, 377, 1, -19, -10],
    [340, 2, 169, 377, 1, -19, -10]
  ],
  animations: {
    gameStop: { speed: 1, frames: [54] },
    gameTalking: {
      speed: 0.25,
      frames: [
        54,
        54,
        1,
        55,
        56,
        3,
        4,
        57,
        58,
        59,
        7,
        60,
        61,
        62,
        63,
        63,
        64,
        65,
        65,
        66,
        66,
        67,
        68,
        11,
        10,
        61,
        69,
        5,
        3,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        43,
        42,
        80,
        81,
        82,
        37,
        83,
        84,
        37,
        38,
        85,
        86,
        41,
        42,
        87,
        88,
        89,
        46,
        90,
        91,
        92,
        50,
        93,
        94,
        95,
        2
      ],
      next: 'gameTalking'
    },
    'game stop': { speed: 1, frames: [0] },
    gameIdle: {
      speed: 0.25,
      frames: [
        0,
        1,
        1,
        2,
        3,
        4,
        4,
        5,
        6,
        7,
        8,
        8,
        9,
        10,
        10,
        11,
        11,
        12,
        13,
        13,
        14,
        15,
        11,
        10,
        16,
        17,
        5,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        2,
        0
      ],
      next: 'gameIdle'
    }
  }
};